import SignUpForm from "./components/SignUpForm";
import VerifyForm from "./components/VerifyForm";
import InfoForm from "./components/InfoForm";
// import ScheduleDemoForm from "./components/ScheduleDemoForm";

export const routes = [
  {
    path: "/",
    redirect: {
      name: "signup"
    }
  },
  {
    path: "/signup",
    name: "signup",
    component: SignUpForm
  },
  {
    path: "/verification",
    name: "verification",
    component: VerifyForm
  },
  {
    path: "/almost-there",
    name: "almostThere",
    component: InfoForm
  },
  // {
  //   path: "/schedule-a-demo",
  //   name: "scheduleDemo",
  //   component: ScheduleDemoForm
  // }
];
